import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Contract } from '../../api/models/contract.model';

interface ContractState {
  filteredContracts: Contract[] | null;
  filters: {
    status?: string;
    search?: string;
  };
  selectedContractDetailsViewId?: string | null;
}

const initialState: ContractState = {
  filteredContracts: null,
  filters: {},
  selectedContractDetailsViewId: null,
};

const contractSlice = createSlice({
  name: 'contracts',
  initialState,
  reducers: {
    setFilteredContracts: (state, action: PayloadAction<Contract[] | null>) => {
      state.filteredContracts = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<ContractState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    clearFilters: (state) => {
      state.filters = {};
    },
    setSelectedContractDetailsViewId: (state, action: PayloadAction<string | null>) => {
      state.selectedContractDetailsViewId = action.payload;
    },
    clearSelectedContractDetailsViewId: (state) => {
      state.selectedContractDetailsViewId = null;
    },
  },
});

export const {
  setFilteredContracts,
  setFilters,
  clearFilters,
  setSelectedContractDetailsViewId,
  clearSelectedContractDetailsViewId
} = contractSlice.actions;
export default contractSlice.reducer;
